import FumbleRecovered from "./fumble-recovered";
import FragmentDataType from "../enums/fragment-data-type";
import { FragmentMessages } from "../../common/fragment-messages";
import FumbleRecoveredByPositionPref from "./position-pref/fumble-recovered-by-position-pref";
import FootballState from "../state/football-state";
import PatFumbleRecoveredByPositionPref from "./position-pref/pat-fumble-recovered-by-position-pref";

export default class FumbleNotRecovered extends FumbleRecovered {
    constructor(recoveredBy, recoveredAt) {
        super();
        this.recoveredBy = recoveredBy;
        this.recoveredAt = recoveredAt;
        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                appliesToOpponent: () => true,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true,
                positionPref: (play) =>
                    play.historyContains(FootballState.PatTry)
                        ? new PatFumbleRecoveredByPositionPref(
                              play,
                              this
                          ).resolve()
                        : new FumbleRecoveredByPositionPref(
                              play,
                              this
                          ).resolve()
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "Recovered At",
                title: "At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION,
                showEndZoneYards: (gameConfig) =>
                    gameConfig.general.includeEndZoneYardage
            }
        ];
    }
}
